export const MAX_IMAGE_FILE_SIZE = 1048576; // 1 megabyte
export const SUPPORTED_FORMATS = ['image/jpg', 'image/jpeg', 'image/png'];
export const MAX_ELEMENTS_TO_DISPLAY = 6;
